/*
* 返回选中日期当天的开始第一秒  YYYY-MM-DD 00:00:00
*
* */
import React, { Component } from 'react';
import DatePickerClientS from '../DatePickerTimeZoneConversion';
require('./index.less');
export default class TZDatePickerStart extends Component {
    constructor(props) {
        super(props);
        this.state = { current: null };
    }

    render() {
        //let Format = 'YYYY-MM-DD';
        let {
            format = ['YYYY-MM-DD', 'YYYYMMDD', 'YYYY.MM.DD', 'YYYY/MM/DD'],
            ...others
        } = this.props;
        return (
            <DatePickerClientS
                format={format}
                {...others}
                MultiTZ={true}
                HHmmss='00:00:00'
                dateInputPlaceholder={'YYYYMMDD'}
                className={`TZDatePickerStart ${this.props.className}`}
            />

        );
    }
}
TZDatePickerStart.defaultProps = {
    showTime: false,
    showClear: true,
    renderIcon: () => {
        return <i className="icon iconfont">&#xe6cd;</i>;
    },
};
